// extracted by mini-css-extract-plugin
export var bubble = "_32-0";
export var container = "_32-f";
export var contrastBorder = "_32-g";
export var greyOut = "_32-2";
export var initialsColor0 = "_32-3";
export var initialsColor1 = "_32-4";
export var initialsColor10 = "_32-d";
export var initialsColor11 = "_32-e";
export var initialsColor2 = "_32-5";
export var initialsColor3 = "_32-6";
export var initialsColor4 = "_32-7";
export var initialsColor5 = "_32-8";
export var initialsColor6 = "_32-9";
export var initialsColor7 = "_32-a";
export var initialsColor8 = "_32-b";
export var initialsColor9 = "_32-c";
export var initialsWrapper = "_32-1";
export var large = "_32-l";
export var medium = "_32-k";
export var mediumSmall = "_32-j";
export var mediumSmallMedium = "_32-o";
export var micro = "_32-h";
export var small = "_32-i";
export var tiny = "_32-n";
export var xTiny = "_32-m";